import React from 'react';
interface SectionHeaderProps {
  id: string;
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  onDark?: boolean;
}
export function SectionHeader({
  id,
  eyebrow,
  title,
  description,
  onDark = false
}: SectionHeaderProps) {
  return <div className="text-center" data-id="element-161" data-mp="22fponx6giqh7">
      {eyebrow && <p className={`font-display text-sm font-semibold leading-tight sm:text-base ${onDark ? 'text-energy' : 'text-electric'}`} data-id="element-162" data-mp="27hyggq7lfmhq">
          {eyebrow}
        </p>}
      <h2 id={id} className={`mt-1 font-display text-[1.45rem] font-extrabold leading-[1.15] sm:text-4xl ${onDark ? 'text-white' : 'text-navy'}`} data-id="element-163" data-mp="3052fmek096ll">
        {title}
      </h2>
      {description && <p className={`mx-auto mt-1.5 max-w-xl text-sm leading-snug sm:text-base ${onDark ? 'text-white/80' : 'text-navy/75'}`} data-id="element-164" data-mp="19t4vcr6f84b0">
          {description}
        </p>}
    </div>;
}